<template>
  <div>
    <v-row id="componentDevolucaoId">
      <v-col
        id="devolucaoPeriodoId"
        cols="12"
        sm="6"
        md="6"
        lg="6"
      >
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="6"
            lg="6"
          >
            <div
              id="texto1"
              class="border1"
            >
              <h4
                id="titulo"
                class="text-center"
              >
                DEVOLUÇÕES DO PERÍODO
              </h4>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="6"
            lg="6"
          >
            <div
              v-if="loading"
              id="idLoading"
              class="text-center"
              :style="styleObject"
            >
              <v-icon
                light
                class="custom-loader"
                :style="styleObject"
              >
                mdi-cached
              </v-icon>
              Carregando dados...
            </div>
            <div
              v-else-if="error"
              class="alert alert-danger"
            >
              {{ error }}
            </div>
            <div
              v-else
              id="texto2"
              class="border2"
            >
              <h4
                id="titulo"
                class="text-center"
                :style="styleFaturamento"
              >
                {{ valorDevolucao }}
              </h4>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <div
              v-if="loading1"
              id="idLoading1"
              class="text-center"
              :style="styleObject"
            >
              <v-icon
                light
                class="custom-loader"
                :style="styleObject"
              >
                mdi-cached
              </v-icon>
              Carregando dados...
            </div>
            <div
              v-else-if="error1"
              id="idDevQuantidade"
              class="alert alert-danger"
            >
              {{ error1 }}
            </div>
            <div id="grafico1">
              <canvas
                id="myChartDevolucaoTotal"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        id="tiposDevolucaoId"
        cols="12"
        sm="6"
        md="6"
        lg="6"
      >
        <dashboard-tipos-devolucao />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Comercial from '../../../../../services/comercialpersonalizacao'
  import eventEmit from '../../core/EventoEmit'
  import Chart from 'chart.js'

  export default {
    name: 'ShowDashboardTiposDevolucoes',
    emits: ['dadosTotalDevolucao'],
    components: {
      DashboardTiposDevolucao: () => import('../../../components/comercial/comercialPersonalizado/TiposDevolucao'),
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleFaturamento: {
        color: '#C62828',
      },
      loading: false,
      error: null,
      loading1: false,
      error1: null,
      dados: [],
      vendedores: [],
      selectMes: [],
      selectAno: [],
      myChart: {},
      labels: [],
      quantidade: [],
      valorDevolucao: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevolucaoEnvio: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
    }),

    created () {
      eventEmit.$on('update-dados-form', this.handleUpdateDados)

      eventEmit.$on('enable-detalhe-devolucao', this.handleUpdateGrafico)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-form', this.handleUpdateDados)

      eventEmit.$off('enable-detalhe-devolucao', this.handleUpdateGrafico)
    },

    methods: {
      handleUpdateDados (selectMes, selectAno, vendedores) {
        this.vendedores = vendedores
        this.selectMes = selectMes
        this.selectAno = selectAno

        this.valorDevolucao = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.showDevolucao()
        this.showGrafico()
      },

      handleUpdateGrafico (valorDevolucaoPrint, labelsDevolucaTotal, quantidadeDevolucao) {
        const widthMobile = window.innerWidth

        this.valorDevolucao = valorDevolucaoPrint

        const ctx = document.getElementById('myChartDevolucaoTotal').getContext('2d')

        this.myChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: labelsDevolucaTotal,
            datasets: [
              {
                label: 'Devolução',
                data: quantidadeDevolucao,
                backgroundColor: '#4780b8',
                order: 1,
              },
            ],
          },
          options: {
            layout: {
              padding: {
                left: widthMobile <= 768 ? 330 : 125, // Ajuste o valor conforme necessário para dar espaço aos labels
              },
            },
            scales: {
              yAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  ticks: {
                    fontSize: 12, // Defina o tamanho da fonte desejado aqui
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    min: 0,
                  },
                },
              ],
            },
            legend: {
              display: false,
            },
            tooltips: {
              callbacks: {
                label: (tooltipItem, data) => {
                  return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kg'
                },
                title: (tooltipItem) => {
                  return labelsDevolucaTotal[tooltipItem[0].index]
                },
              },
            },
          },
        })
      },

      async showDevolucao () {
        this.loading = true
        this.error = false

        await Comercial.showValorDevolucao(this.selectMes, this.selectAno, this.vendedores, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorDevolucao = resposta.data.valorDevolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Empresa não encontrada') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      async showGrafico () {
        this.loading1 = true
        this.error1 = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Comercial.showGraficoDevolucao(this.selectMes, this.selectAno, this.vendedores, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            const widthMobile = window.innerWidth

            this.labels = resposta.data.labels
            this.quantidade = resposta.data.quantidade
            this.valorDevolucaoEnvio = resposta.data.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const ctx = document.getElementById('myChartDevolucaoTotal').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'horizontalBar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Devolução',
                    data: resposta.data.quantidade,
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                ],
              },
              options: {
                layout: {
                  padding: {
                    left: widthMobile <= 768 ? 330 : 125, // Ajuste o valor conforme necessário para dar espaço aos labels
                  },
                },
                scales: {
                  yAxes: [
                    {
                      gridLines: {
                        display: false,
                      },
                      ticks: {
                        fontSize: 12, // Defina o tamanho da fonte desejado aqui
                      },
                    },
                  ],
                  xAxes: [
                    {
                      ticks: {
                        min: 0,
                      },
                    },
                  ],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kg'
                    },
                    title: (tooltipItem) => {
                      return resposta.data.labels[tooltipItem[0].index]
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há devoluções para os filtros selecionados') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.error1 = resposta.data.text

            this.showSnackbar('error', 3000, 'resposta.data.text')
          } else if (resposta.data.text === 'Empresa não encontrada') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.error1 = resposta.data.text

            this.showSnackbar('error', 3000, 'resposta.data.text')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error1 = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading1 = false

          eventEmit.$emit('dados-total-devolucao', this.labels, this.quantidade, this.valorDevolucaoEnvio)
        })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    .border1 {
      width: 15rem;
    }

    #texto2 {
      margin: -3.4rem 0 0 14rem
    }
    .border2 {
      width: 14rem;
    }

    #myChartDevolucaoTotal {
      margin: -3rem 0 0 -2rem;
      width: 400px !important;
      height: 250px !important;
    }

    #idDevQuantidade {
      margin: 4rem 0 0 2rem;
      font-size: 16px;
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width: 1380px)
  and (max-width: 1901px) {
    .border1 {
      width: 21.5rem;
    }

    .border2 {
      width: 21.5rem;
    }

    #texto2 {
      margin: 0 0 0 -6.9rem
    }

    #myChartDevolucaoTotal {
      width: 636px !important;
      height: 325px !important;
      margin: 0 0 0 -5rem;
    }
  }

  @media screen
  and (min-width: 1902px) {
    .border1 {
      width: 26rem;
    }

    .border2 {
      width: 26rem;
    }

    #texto2 {
      margin: 0 0 0 -8.15rem;
    }

    #myChartDevolucaoTotal {
      width: 823px !important;
      height: 412px !important;
      margin: 0 0 0 -9rem;
    }
  }
</style>

<style lang="sass">
  .border1
    border: inset
    width: 18rem

  #idLoading
    margin: 0 0 0 -15rem

  #idLoading1
    margin: 5rem 0 0 -10rem

  .border2
    border: inset
    width: 18rem

  #texto1
    margin: 0 0 0 -1rem

  #texto2
    margin: 0 0 0 -6rem

  #texto3
    margin: 0 0 0 -11rem

  #texto4
    margin: 0 0 0 -8.3rem

  #texto5
    margin: 0 0 0 -5.7rem

  #titulo
    background: gray

  .valorDevolucao
    border: inset
    width: 14.9rem

  #myChartDevolucaoTotal
    width: 477px !important
    height: 275px !important

  #idDevQuantidade
    margin: 4rem 0 0 4rem
    font-size: 16px
    color: red

</style>
